import { getChannelAPIPath } from '@treasury/core/http';

ResearchTransactionsService.$inject = ['$resource', '$http'];

export default function ResearchTransactionsService($resource, $http) {
    return {
        getResearchTransactionList,
    };

    function getResearchTransactionList(researchTransactionFilter) {
        return $http({
            method: 'post',
            url: `${getChannelAPIPath()}researchTransactions/`,
            data: researchTransactionFilter,
        }).then(response => response.data);
    }
}
